// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function execute(payload) {
  return {
          geo_region_id: payload.geo_region_id,
          vehicle_id: payload.vehicle_id,
          zone_ids: payload.zone_ids,
          cluster_ids: payload.cluster_ids,
          campaign_name: payload.campaign_name,
          effective_from: payload.effective_from,
          effective_till: payload.effective_till,
          _type: payload._type,
          sub_type: payload.sub_type,
          values: {
            _type: payload.sub_type,
            auto: payload.values.auto,
            manual: payload.values.manual,
            threshold: payload.values.threshold,
            ratio: payload.values.ratio,
            radius_delta: payload.values.radius_delta
          },
          days_of_week: payload.days_of_week,
          day_start_hour: payload.day_start_hour,
          day_start_min: payload.day_start_min,
          day_end_hour: payload.day_end_hour,
          day_end_min: payload.day_end_min,
          validations: Belt_Option.map(payload.validations, (function (validationData) {
                  return {
                          validations: Belt_Array.map(validationData.validations, (function (item) {
                                  return {
                                          validation_type: item.validation_type,
                                          segment_names: item.segment_names
                                        };
                                }))
                        };
                }))
        };
}

export {
  execute ,
  
}
/* No side effect */
